export const ERROR_CLEARALL = "ERROR_CLEARALL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const SET_ACCESS_MENU = "SET_ACCESS_MENU";
export const SET_AGENT_PERMISSION = "SET_AGENT_PERMISSION";
export const SET_ERROR = "SET_ERRORSTATUSNCOLOR";
export const SET_INBOUND_SAVE_TICKET = "SET_INBOUND_SAVE_TICKET";
export const SET_LOGOUT_CLEAR = "SET_LOGOUT_CLEAR";
export const SET_SIP_PARAM = "SET_SIP_PARAM";
export const SET_STATUSNCOLOR = "SET_STATUSNCOLOR";
export const SET_STATUSNCOLOR_CLEAR = "SET_STATUSNCOLOR_CLEAR";
export const SUCCESS_MESSAGE_CLEAR = "SUCCESS_MESSAGE_CLEAR";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
